import { Stack } from "expo-router";
import { useAuthContext } from "@/features/auth/hooks/use-auth-context";

export default function AuthLayout() {
  const { isLoggedIn } = useAuthContext();

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Protected guard={!isLoggedIn}>
        <Stack.Screen name="index" />
        <Stack.Screen name="login" />
        <Stack.Screen name="signup" />
        <Stack.Screen name="forgot-password" />
      </Stack.Protected>
      <Stack.Protected guard={isLoggedIn}>
        <Stack.Screen name="complete-profile" />
      </Stack.Protected>
    </Stack>
  );
}
